import { Option } from "../../util/option";
import { GetFileLayout } from "../../services/data-kinds";
import { DisplayColumn, ErrorMessage } from "../../util/spreadsheet-data-utils";

export type FileLayoutMaintenancePageState = {
  isSaved: boolean;
  searchResult: {
    fileLayoutList: FileLayout[];
  };
  spreadsheetSelectedRowIndex: number | undefined;
  dataList: DataList;
  displayColumn: DisplayColumn[];
};

export type FileLayout = {
  /**
   * Row Number
   */
  rowNum: number;

  /**
   * Add Flag
   */
  addFlg: string;

  /**
   * Add Flag
   */
  isEdited: boolean;

  /**
   * get-data-kind response
   */
  getFileLayout: GetFileLayout;

  /**
   * for error
   */
  errorColumnList: string[];
  errorMessage: string;
  messageList: ErrorMessage[];
};
export type FileLayoutKeys = keyof GetFileLayout;
export type DataList = {
  inDefCommonFlagType: Option[];
  layoutDerivationReasonType: Option[];
};
export type PageNewState =
  | FileLayoutMaintenancePageState
  | ((
      prevState: FileLayoutMaintenancePageState,
    ) => FileLayoutMaintenancePageState);
